/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

